import React, { useState } from 'react';
import { Modal, message } from 'antd';
import { useParams } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';

import InputStyled from 'components/InputStyled';
import { IVisible } from '..';

import { itemApis } from 'apis/package/itemApis';
import SelectBox from 'components/SelectBox';
import InputWithCounter from 'components/input/InputWithCounter';
import { DefaultInputCountConfig } from 'utils/types/storyTypes';

/**
 * * 아이템 등록 모달
 */

interface IProps {
  visible: IVisible;
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  itemType: any;
}

const CreateModal = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
  itemType,
}: IProps) => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const [inputValue, setInputValue] = useState<string>('');
  const [itemTypeSelect, setItemTypeSelect] = useState<string>('');

  const [loading, setLoading] = useState(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (projectId) {
      if (inputValue.includes(' ')) {
        handleMessage(
          message,
          'error',
          `아이템 생성시 여백이 포함될 수 없습니다. '_' 혹은 '-'을 사용하세요`,
        );
        return;
      }

      try {
        const postData = {
          origin_name: inputValue,
          item_type: itemTypeSelect,
        };
        setLoading(true);
        await itemApis.itemCreate(projectId, postData);
        setRefresh(!refresh);
        setLoading(false);
        handleClose();
      } catch (err) {
        setLoading(false);
        handleMessage(message, 'error', 'Upload failed');
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, create: false });
    setInputValue('');
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.

    setRefresh(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.operationContent.modal.create.title',
      )}
      open={visible.create}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.create')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <div>
          <p className='title'>
            {t(
              'storyEpisodeID.storyTabMenuList.operationContent.modal.create.name',
            )}
          </p>
          <InputWithCounter
            value={inputValue}
            onChange={(e) => {
              handleInputChange(e);
            }}
            maxLength={30}
            placeholder='스크립트에서 사용되는 아이템명 등록(공백 입력 불가)'
            count={DefaultInputCountConfig}
          />
          <p className='length-subtext'>
            {typeof inputValue.length === 'number'
              ? `${inputValue.length}/30 characters`
              : '0/30 characters'}
          </p>
        </div>
        <div>
          <p className='title'>
            {t(
              'storyEpisodeID.storyTabMenuList.operationContent.modal.create.type',
            )}
          </p>
          <SelectBox
            value={itemTypeSelect}
            onChange={(e) => {
              setItemTypeSelect(`${e}`);
            }}
            options={itemType?.map((v, i) => {
              return {
                value: v.code,
                label: v.code_name,
              };
            })}
          />
        </div>
      </SectionWarpper>
    </CustomModal>
  );
};

export default CreateModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
`;
